<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش پس انداز ها به تفکیک ماه" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="4">
							<div>
								<div>تاریخ شروع</div>
								<date-picker ref="startDate" v-model="startDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit clearable />
								<div class="red--text">
									{{ startDateValidatioin }}
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="4">
							<div>
								<div>تاریخ پایان</div>
								<date-picker ref="endDate" v-model="endDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" auto-submit clearable />
								<div class="red--text">
									{{ endDateValidatioin }}
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="4" style="text-align:left">
							<v-btn color="primary" dark class="mx-1" @click="loadData">
								دریافت اطلاعات
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :headers="headers" :items="items" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											{{ row.item.month }}
										</td>
										<td class="text-center">
											{{ row.item.valueByFile.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.valueNoFile.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.value.toString().toPriceFormat() }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'CheckoutThisMonth',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				errorMessages: '',
				startDate: '',
				startDateValidatioin: '',
				endDateValidatioin: '',
				endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'ماه',
						align: 'start',
						sortable: true,
						value: 'month',
					}, {
						text: 'دریافت شده توسط فایل',
						align: 'center',
						sortable: true,
						value: 'valueByFile',
					}, {
						text: 'ثبت دستی',
						align: 'center',
						sortable: true,
						value: 'valueNoFile',
					}, {
						text: 'مجموع',
						align: 'center',
						sortable: true,
						value: 'value',
					},
				],
				items: [],
			}
		},
		mounted() {
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/report/SaveMoniesByMonth/?start=' + this.startDate + '&end=' + this.endDate, {})
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style>
</style>
